<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import { quadIn, quadOut } from 'svelte/easing';
	import { prefersReducedMotion } from 'svelte/motion';
	import { fly } from 'svelte/transition';

	interface Props extends HTMLAttributes<HTMLTableRowElement> {
		rowClass?: ClassValue;
		children?: Snippet;
	}

	const { rowClass, children, ...restProps }: Props = $props();
</script>

<tr
	{...restProps}
	class={['b-b b-b-solid border-neutral-soft max-w-full text-left max-md:grid max-md:grid-cols-[repeat(1,minmax(0,100%))] md:relative', rowClass]}
	in:fly={{ y: prefersReducedMotion.current ? 0 : '-25%', duration: 100, easing: quadIn }}
	out:fly={{ y: prefersReducedMotion.current ? 0 : '-25%', duration: 100, easing: quadOut }}
>
	{@render children?.()}
</tr>
